import { render, staticRenderFns } from "./ChannelWidget.vue?vue&type=template&id=d335da4e&scoped=true"
import script from "./ChannelWidget.vue?vue&type=script&lang=js"
export * from "./ChannelWidget.vue?vue&type=script&lang=js"
import style0 from "./ChannelWidget.vue?vue&type=style&index=0&id=d335da4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d335da4e",
  null
  
)

export default component.exports